var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApplications(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5V5H2.5V2.5H5ZM6.25 1.25H1.25V6.25H6.25V1.25ZM11.25 2.5V5H8.75V2.5H11.25ZM12.5 1.25H7.5V6.25H12.5V1.25ZM17.5 2.5V5H15V2.5H17.5ZM18.75 1.25H13.75V6.25H18.75V1.25ZM5 8.75V11.25H2.5V8.75H5ZM6.25 7.5H1.25V12.5H6.25V7.5ZM11.25 8.75V11.25H8.75V8.75H11.25ZM12.5 7.5H7.5V12.5H12.5V7.5ZM17.5 8.75V11.25H15V8.75H17.5ZM18.75 7.5H13.75V12.5H18.75V7.5ZM5 15V17.5H2.5V15H5ZM6.25 13.75H1.25V18.75H6.25V13.75ZM11.25 15V17.5H8.75V15H11.25ZM12.5 13.75H7.5V18.75H12.5V13.75ZM17.5 15V17.5H15V15H17.5ZM18.75 13.75H13.75V18.75H18.75V13.75Z",
    fill: "#B0B1B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplications);
export default __webpack_public_path__ + "static/media/Applications.143cba5e5d81c1ee26b3f771355f226f.svg";
export { ForwardRef as ReactComponent };